<div class="space-y-8">
  <div class="flex items-center justify-between">
    <div>
      <p class="text-sm text-slate-500">Cliente</p>
      <p class="text-base font-semibold text-slate-900">{{ getCustomerName(payment()) }}</p>
    </div>
    <span class="px-2 py-1 text-xs font-medium rounded-full"
      [class.bg-green-100]="payment().status === 'PAID'"
      [class.text-green-800]="payment().status === 'PAID'"
      [class.bg-red-100]="payment().status === 'FAILED' || payment().status === 'CANCELLED'"
      [class.text-red-800]="payment().status === 'FAILED' || payment().status === 'CANCELLED'"
      [class.bg-amber-100]="payment().status === 'PENDING' || payment().status === 'EXPIRED'"
      [class.text-amber-800]="payment().status === 'PENDING' || payment().status === 'EXPIRED'">
      {{ getPaymentRecordStatusLabel(payment().status) || '-' }}
    </span>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <p class="text-xs text-slate-500 uppercase">ID</p>
      <p class="text-sm font-medium text-slate-900">{{ payment().id }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Monto</p>
      <p class="text-sm font-medium text-slate-900">{{ formatMoney(payment().amount, payment().currency?.code) }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Comisión</p>
      <p class="text-sm font-medium text-slate-900">{{ formatMoney(payment().amountFee, payment().currency?.code) }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Monto neto</p>
      <p class="text-sm font-medium text-slate-900">{{ formatMoney(payment().amountNet, payment().currency?.code) }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Moneda</p>
      <p class="text-sm font-medium text-slate-900">{{ payment().currency?.code || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Forma de pago</p>
      <p class="text-sm font-medium text-slate-900">{{ getPaymentFormLabel(payment().paymentForm) || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Banco</p>
      <p class="text-sm font-medium text-slate-900">{{ payment().bank || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Fecha de pago</p>
      <p class="text-sm font-medium text-slate-900">{{ formatDateTime(payment().paidAt) }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Venta relacionada</p>
      @if (payment().sale?.id) {
        <button
          type="button"
          class="text-sm font-medium text-sky-600 hover:text-sky-800 hover:underline"
          (click)="openRelatedSale()">
          {{ payment().sale?.number || ('#' + payment().sale?.id) }}
        </button>
      } @else {
        <p class="text-sm font-medium text-slate-900">-</p>
      }
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Cargo</p>
      <p class="text-sm font-medium text-slate-900">{{ payment().chargeId || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Proveedor</p>
      <p class="text-sm font-medium text-slate-900">{{ getPaymentProviderLabel(payment().paymentProvider) || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">ID proveedor</p>
      <p class="text-sm font-medium text-slate-900 break-all">{{ payment().providerId || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Mensaje de resultado</p>
      <p class="text-sm font-medium text-slate-900">{{ payment().resultMessage || '-' }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Creado</p>
      <p class="text-sm font-medium text-slate-900">{{ formatDateTime(payment().createdAt) }}</p>
    </div>
    <div>
      <p class="text-xs text-slate-500 uppercase">Actualizado</p>
      <p class="text-sm font-medium text-slate-900">{{ formatDateTime(payment().updatedAt) }}</p>
    </div>
  </div>

</div>
